import React from 'react'
import { authPredicate } from '../stores/mainStore'
import { Route } from 'react-router-dom'
import RedirectToICAS from '../components/Pages/ICAS/RedirectToICAS'

export const renderProtectedPage =
  (isAuthenticated) => (Component) => (props) =>
    isAuthenticated() ? <Component {...props} /> : <RedirectToICAS />

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={renderProtectedPage(authPredicate)(Component)} />
)

export default PrivateRoute
